import { Route, Routes as RoutesContainer } from 'react-router';

import {
  AgentUser,
  BestCoaches,
  Coaches,
  Competition,
  CompetitionAgent,
  CompetitionProvinceRank,
  CompetitionRank,
  CompetitionRegister,
  Create,
  Edit,
  Leagues,
  Supervisors,
  Teams,
  Users,
  UsersLeague,
  UsersTeam,
} from '../index';

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/competition' element={<Competition />} />
      <Route exact path='/competition/create' element={<Create />} />
      <Route exact path='/competition/edit/:id' element={<Edit />} />
      <Route exact path='/competition-register/:id/user' element={<Users />} />
      <Route exact path='/competition-register/:id/team' element={<Teams />} />
      <Route
        exact
        path='/competition-register/:id/team/:teamId/users'
        element={<UsersTeam />}
      />
      <Route
        exact
        path='/competition-register/:id/league'
        element={<Leagues />}
      />
      <Route
        exact
        path='/competition-register/:id/league/:leagueId/users'
        element={<UsersLeague />}
      />
      <Route
        exact
        path='/competition-register/:id/coach'
        element={<Coaches />}
      />
      <Route
        exact
        path='/competition-register/:id/supervisor'
        element={<Supervisors />}
      />
      <Route
        exact
        path='/competition/competition-register'
        element={<CompetitionRegister />}
      />

      <Route
        exact
        path='/competition/competition-register/:id/rule'
        element={<CompetitionRank />}
      />
      <Route
        exact
        path='/competition/:id/agent'
        element={<CompetitionAgent />}
      />
      <Route
        exact
        path='/competition/:id/agent/users'
        element={<AgentUser />}
      />
      <Route
        exact
        path='/competition/:id/best-coach'
        element={<BestCoaches />}
      />

      <Route
        exact
        path='/competition/:id/province-rank'
        element={<CompetitionProvinceRank />}
      />
    </RoutesContainer>
  );
};
export default Routes;
